const consulta_de_vagas_por_ensino_e_bairro = {
  path: "/consulta-de-vagas-por-ensino-bairro",
  redirect: "/consulta-de-vagas-por-ensino-bairro",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Consulta de Vagas",
  },
  children: [
    {
      path: "/consulta-de-vagas-por-ensino-bairro",
      name: "consulta-de-vagas-por-ensino-bairro",
      meta: {
        allowedPermissions: ["consulta_vagas_ensino_bairro"],
      },
      component: () =>
        import(
          "@/views/ConsultaDeVagasPorEnsinoBairro/ConsultaDeVagasPorEnsinoBairro.vue"
        ),
    },
  ],
};

export { consulta_de_vagas_por_ensino_e_bairro };
